"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dayjs_1 = __importDefault(require("dayjs"));
const tomorrowPlugin = (_option, dayjsClass) => {
    dayjsClass.prototype.tomorrow = function () {
        return this.add(1, 'day');
    };
};
dayjs_1.default.extend(tomorrowPlugin);
